import { ArrowLeft, Grid2X2 } from "lucide-react";
import { Link } from "react-router-dom";

type ConceptBarProps = {
  label: string;
  dark?: boolean;
};

export function ConceptBar({ label, dark = false }: ConceptBarProps) {
  return (
    <div className={`concept-bar ${dark ? "concept-bar--dark" : ""}`}>
      <Link to="/" aria-label="Вернуться к списку концептов">
        <ArrowLeft size={16} aria-hidden="true" />
        <span>Портфолио</span>
      </Link>
      <span className="concept-bar__status">{label}</span>
      <Link to="/" aria-label="Открыть все концепты">
        <Grid2X2 size={16} aria-hidden="true" />
      </Link>
    </div>
  );
}
